"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
var react_1 = __importDefault(require("react"));
var link_1 = __importDefault(require("next/link"));
var Link = function (_a) {
    var children = _a.children, _b = _a.route, route = _b === void 0 ? '' : _b, _c = _a.target, target = _c === void 0 ? '_self' : _c, params = _a.params, hash = _a.hash, _d = _a.shallow, shallow = _d === void 0 ? true : _d, className = _a.className, id = _a.id;
    return (react_1.default.createElement(link_1.default, { href: {
            pathname: route,
            query: __assign({}, params),
            hash: hash,
        }, shallow: shallow, className: className, target: target, id: id }, children));
};
exports.Link = Link;
